import {createApp} from 'vue';
import {connectVue} from '../modules/configureBugsnag';
import configureGlobalComponents from '../modules/configureGlobalComponents';
import axiosClient from '../modules/axiosClient';
import Stars from '../components/global/stars.vue';

const app = createApp({
    components: {
        'stars': Stars,
    },
    props: {
        ratingStar: {type: Array},
        totalCount: {type: Number},
        recordsCount: {type: Number},
        displayAddReview: {type: Boolean},
        canAddReview: {type: Boolean},
        make: {type: String},
        model: {type: String},
    },
    data() {
        return {
            resultPage: 1,
            resultRecords: [],
            isLoadingResults: false,
            filterRating: '',
        };
    },
    mounted() {
        this.loadData();
    },
    watch: {
        filterRating() {
            this.filterReview();
        },
    },

    computed: {
        showButton(): boolean {
            return this.resultRecords.length === this.resultPage * 4 || this.isLoadingResults;
        },
    },

    methods: {
        filterReview() {
            this.resultPage = 1;
            this.resultRecords = [];

            this.loadData();
        },
        nextPage() {
            this.resultPage++;
            this.loadData();
        },
        loadData() {
            this.isLoadingResults = true;

            let url = `/api/car-reviews/${this.make}_${this.model}` +
                `/user-reviews/more/${this.resultPage}`;

            if (this.filterRating) {
                url = url + `/${this.filterRating}`;
            }

            axiosClient.get(url)
                .then((response) => {
                    if (response.data != '') {
                        const data = response.data;
                        this.resultRecords = this.resultRecords.concat(data.data);
                        this.isLoadingResults = false;
                    }
                });
        },
    },
}, window.propsData);

connectVue(app);
configureGlobalComponents(app);

app.mount('#app');
